<template>
    <div>
        <div class="row g-3">
            <div class="col">
                <label class="form-label x-small-mb">Nombre de la licencia</label>
                <input type="text" v-model="newUser.name" class="form-control" placeholder="Nombre de la licencia"
                    aria-label="Nombre de la licencia" />
            </div>
            <span class="text-danger" v-if="error.name">El nombre de la licencia es un campo obligatorio</span>
        </div>

        <div class="row g-3">
            <div class="col m-0">
                <label class="form-label x-small-mb">Número de usuarios disponibles</label>
                <input type="number" min="0" v-model="newUser.accepted_users" class="form-control"
                    placeholder="Apellido del usuario" aria-label="Apellido del usuario" />

                <span class="text-danger" v-if="error.accepted_users">El apellido del usuario es un campo
                    obligatorio</span>
            </div>
            <div class="col m-0">
                <label class="form-label x-small-mb">Número de rutas disponibles</label>
                <input type="number" min="0" v-model="newUser.accepted_routes" class="form-control"
                    placeholder="Rutas disponibles" aria-label="Rutas disponibles" />

                <span class="text-danger" v-if="error.accepted_users">{{ error }} <br /></span>
            </div>
            <div class="col m-0">
                <label class="form-label x-small-mb">Número total de cursos</label>
                <input type="email" min="0" v-model="newUser.accepted_courses" class="form-control"
                    placeholder="Total de cursos" aria-label="Total de cursos" />

                <span class="text-danger" v-if="error.accepted_courses">{{ error }} <br /></span>
            </div>
        </div>
        <div class="row g-3">
            <label class="form-label pb-0 x-small-mb">Tiempo de Licencia</label>
            <div class="col m-0 pt-0">
                <input type="number" v-model="newUser.digits" class="form-control" placeholder="Tiempo de la Licencia"
                    aria-label="Tiempo de la Licencia" />
                <span class="text-danger" v-if="error.digits">Por favor ingrese el tiempo de licencia.</span>
            </div>
            <div class="col m-0 pt-0">
                <select v-model="newUser.typeTime" class="form-control">
                    <option value="" selected="selected" disabled>Seleccione el tipo de tiempo</option>
                    <option value="hours">Horas</option>
                    <option value="days">Días</option>
                    <option value="month">Meses</option>
                    <option value="years">Años</option>
                </select>
                <span class="text-danger" v-if="error.expiration_date">Por favor seleccione el tipo de tiempo de la
                    licencia.</span>
            </div>
        </div>

        <div class="mt-3 pt-4 text-end">
            <button id="closeAdd" type="button" class="btn btn-utel btn-inverted me-3 d-none d-lg-block" @click="
                newUser = {
                    name: '',
                    accepted_users: 0,
                    accepted_routes: 0,
                    accepted_courses: 0,
                }
            ">
                Descartar
            </button>
            <button id="agregar" type="button" @click="agregarCliente" class="btn btn-utel text-light">
                Crear plan
            </button>
            <button id="closeAdd" type="button" class="btn btn-utel btn-inverted me-3 d-lg-none mt-3" @click="
                newUser = {
                    name: '',
                    accepted_users: 0,
                    accepted_routes: 0,
                    accepted_courses: 0,
                }
            ">
                Descartar
            </button>
        </div>

        <div id="msj-success" class="text-success text-center mt-4" style="display: none;">
            <h4 class="fw-bold">Plan empresarial creado exitosamente.</h4>
            <a href="/dashboard/licences" class="text-dark fw-bold fs-5">Ver todos los planes <i
                    class="fa-solid fa-magnifying-glass"></i></a>
        </div>
    </div>
</template>

<script>
export default {
    props: ["get"],
    data() {
        return {
            url: this.get,
            newUser: {
                name: "",
                accepted_users: 0,
                accepted_routes: 0,
                accepted_courses: 0,
                digits: null,
                typeTime: '',
            },
            error: [],
        };
    },
    mounted() {
        this.getData();
        console.log(this.roles);
    },
    methods: {
        getData() {
            axios.get(this.url).then((res) => {
                this.desserts = res.data;
            });
        },
        agregarCliente() {
            let btn = document.getElementById("agregar");
            let cancel = document.getElementById("closeAdd");
            let msj = document.getElementById("msj-success");
            //let modal = document.getElementById("addModal");
            //let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .post(this.url, this.newUser)
                .then((res) => {
                    this.newUser = {
                        name: "",
                        accepted_users: 0,
                        accepted_routes: 0,
                        accepted_courses: 0,
                    };
                    btn.textContent = res.data.message;
                    msj.style.display = "block";
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        btn.textContent = "Guardar usuario";
                        this.getData();
                        //modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((err) => {
                    cancel.removeAttribute("disabled");
                    btn.removeAttribute("disabled");
                    btn.textContent = "Guardar proceso";
                    this.error = err.response.data.errors;
                });
        },
    },
};
</script>
